import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import MatrixCell from "./MatrixCell";
import { LINGUIST_COL_WIDTH } from "./MatrixHeaderRow";
import { CELL_HEIGHT } from "./MatrixCell";

const MatrixRow = memo(({ linguist, dates, userCells, onCellClick, readOnly }) => (
  <Box sx={{ display: "flex" }}>
    <Box
      sx={{
        width: LINGUIST_COL_WIDTH,
        minWidth: LINGUIST_COL_WIDTH,
        height: CELL_HEIGHT,
        position: "sticky",
        left: 0,
        zIndex: 2,
        bgcolor: "background.paper",
        borderRight: "1px solid",
        borderBottom: "1px solid",
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        px: 1,
      }}
    >
      <Typography variant="body2" noWrap title={linguist.name}>
        {linguist.name}
      </Typography>
    </Box>
    {dates.map(date => (
      <MatrixCell
        key={date}
        cell={userCells?.[date]}
        disabled={readOnly}
        onClick={e => onCellClick(e, linguist, date, userCells?.[date])}
      />
    ))}
  </Box>
));

MatrixRow.displayName = "MatrixRow";

export default MatrixRow;
